<template>
  <div class="details">
    <div class="intro">
      <h4>Addresses</h4>
    </div>
    <Table
      :items="addresses"
      :attributes="tableAttributes"
      :options="tableOptions"
      @edit="editAddress"
      @head="addAddress"
    ></Table>
    <SupporterAddAddress :supporter="supporter" v-if="isOpen(modalNames.ADD_ADDRESS)"></SupporterAddAddress>
    <SupporterEditAddress
      :supporter="supporter"
      :canEdit="canEdit"
      :address="address"
      v-if="isOpen(modalNames.EDIT_ADDRESS)"
    ></SupporterEditAddress>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';
import { MODAL_NAME } from '../../stores/supporters';
import SupporterAddAddress from './SupporterAddAddress.vue';
import SupporterEditAddress from './SupporterEditAddress.vue';

export default {
  name: 'SupporterViewAddresses',
  components: {
    Table,
    SupporterAddAddress,
    SupporterEditAddress,
  },

  data() {
    return {
      isLoading: false,
      address: null,
      tableOptions: {
        edit: false,
        pages: [5],
      },
      tableAttributes: [
        { name: 'addressLines', label: 'Address' },
        { name: 'label', label: 'label' },
        { name: 'isPrimary', label: 'Primary', type: 'tick' },
        { name: 'doNotMail', label: "Don't Mail", type: 'tick' },
      ],
    };
  },

  props: {
    addresses: Array,
    supporter: Object,
    canEdit: Boolean,
  },
  computed: {
    modalNames() {
      return MODAL_NAME;
    },
  },
  methods: {
    isOpen(modalName) {
      return this.$store.getters['supporters/isOpen'](modalName);
    },
    open(modalName) {
      this.$store.commit('supporters/open', modalName);
    },
    addAddress() {
      this.open(MODAL_NAME.ADD_ADDRESS);
    },
    editAddress(address) {
      this.address = address;
      this.open(MODAL_NAME.EDIT_ADDRESS);
    },
  },
};
</script>
